import { render } from "./RechargeFailView.vue?vue&type=template&id=1c4b00be"
import script from "./RechargeFailView.vue?vue&type=script&lang=js"
export * from "./RechargeFailView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__